webpackJsonp([31524355450106],{

/***/ 460:
/***/ (function(module, exports) {

	module.exports = {"data":{"contentfulBlogPost":{"title":"MSA featured by Verity","publicationDate":"December 27, 2017","content":{"content":"![MSA featured by Verity Thumbnail](//images.contentful.com/1o5ly3na7qu2/3mmTGWSJIQ0Sa48AGeQSaW/34fd68b76f37d9d678b546499e493066/cropped-verity-logo-v3.png)\n\nThe online news agency Verity featured the Manila Street Astronomers.\n\nRead our feature entitled\n\n[Manila Street Astronomers: An Over the Moon Experience](https://theveritynews.wordpress.com/2017/12/06/manila-street-astronomers-an-over-the-moon-experience-2/ \"Manila Street Astronomers: An Over the Moon Experience\")\n"},"thumbnail":{"file":{"url":"//images.ctfassets.net/1o5ly3na7qu2/3mmTGWSJIQ0Sa48AGeQSaW/34fd68b76f37d9d678b546499e493066/cropped-verity-logo-v3.png"}}}},"pathContext":{"id":"c40VEMkfyEwUeMc4WAaqioa"}}

/***/ })

});


// WEBPACK FOOTER //
// path---blog-msa-featured-by-verity-eb1fd17cf3e56d9c267a.js